export default __webpack_public_path__ + "static/media/profile-4x6-placeholder.58e3b448.jpg";